import type { ComponentSchema } from '../../../../../schema-types'

/** Prottoho text page: band title, rich text and optional FAQ accordion. Keys follow lightings-1. */
export const schema: ComponentSchema = {
  type: 'content',
  label: 'Content page',
  description: 'Policies, about, FAQ and other text pages, with an optional question-and-answer list.',
  supportedPages: ['privacy-policy', 'terms-of-service', 'shipping-policy', 'return-policy', 'track-order'],
  variants: [{ id: 'v1', label: 'Readable column' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string' },
    { key: 'subtitle', label: 'Subtitle', type: 'localized-text' },
    { key: 'content', label: 'Text', type: 'rich-text' },
    {
      key: 'faqs',
      label: 'Questions and answers',
      type: 'array',
      help: 'Shown as an accordion under the text (also published as FAQ structured data).',
      itemSchema: [
        { key: 'question', label: 'Question', type: 'string' },
        { key: 'answer', label: 'Answer', type: 'text' },
      ],
    },
    { key: 'updatedText', label: 'Last updated note', type: 'string', placeholder: 'Last updated 1 January 2026' },
  ],
}
